import { Component, effect, output, signal, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: "app-search-box",
  standalone: true,
  imports: [FormsModule, TooltipModule],
  templateUrl: "./search-box.component.html",
  styleUrl: "./search-box.component.css",
})
export class SearchBoxComponent {
 
  @Input() tooltipText: string = "";
  searchTerm = signal("");
  @Input() set value(v: string | null) {
    if (v !== null && v !== undefined && v !== this.searchTerm()) {
      this.lastValue = v;
      this.searchTerm.set(v);
    }
  }
  search = output<string>();
  private lastValue = "";

  private readonly debounceMs = 400;
  private debounceTimer: any;

  constructor() {
    effect(() => {
      const term = this.searchTerm();
      if (term === this.lastValue) return;
      this.lastValue = term;
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.search.emit(term.trim());
      }, this.debounceMs);
    });
  }
}
